module.exports = __webpack_public_path__ + "img/false.6f37615d.svg";